<template>
  <div class="home-bg">
    <div class="show-div" align="center">
      <span class="show-phone">{{ $t('viewBase.promptmobilelogin') }}</span>
    </div>
    <van-cell-group style="border-top: 0px solid #ebedf0;">
      <van-field v-model="phone" type="tel" :placeholder="$t('viewBase.promptmobilelogin')" clearable>
        <div slot="left-icon" class="sy-cell">
          <div class="sy-cell" @click="show=true">
            
            <span class="color333">{{ telAreaCode }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </van-field>
    </van-cell-group>
    <template v-if="vueAppType!=='TWGUIDER'">
      <div align="center" @click="sendPhoneCode">
        <van-button round type="danger">{{ $t('viewBase.putcode') }}</van-button>
      </div>
    </template>
    <template v-else>
      <div align="center" @click="onInput">
        <van-button round type="danger">{{ $t('viewBase.bindnow') }}</van-button>
      </div>
    </template>

    <van-action-sheet v-model="show" :lazy-render="false" :title="$t('viewBase.phoneadress')">
      <initTelphone ref="initTelphone" />
    </van-action-sheet>
  </div>
</template>

<script>
import { isMobile,isPhoneAtAll } from '@/utils/tool'
import { Toast } from 'vant'
import initTelphone from '../initTelphone/index'
import { bindUserPhoneSendCode, bindUserPhoneVerify, bindUserPhoneVerifyLine } from '@/api/mine'
import { setToken, getAccountId, setAccountId } from '@/utils/auth'
export default {
  components: {
    initTelphone
  },
  data() {
    return {
      phone: '',
      show: false,
      vueAppType:process.env.VUE_APP_TYPE,
    }
  },
  computed: {
    telAreaCode() {
      console.log(this.$store.state.initTelphone.no)
      return this.$store.state.initTelphone.no ? '+' + this.$store.state.initTelphone.no : '+86'
    }
  },
  created() {
    
  },
  methods: {
    sendPhoneCode: function() {
      var this_ = this
      const { telAreaCode } = this
      if (!isPhoneAtAll(this.phone,this.$store.state.initTelphone.phoneFormat)) {

        return Toast({
          message: this.$t('viewBase.phoneformaterror'),
          duration: 1500
        })
      }
      this_.$router.push({
        path: '/bind/code',
        query: {
          phone: this_.phone,
          areaCode: telAreaCode
        }
      })
    },
    initFun: function() {
      var u = navigator.userAgent
      if (u.indexOf('guider-ios') > -1) { // ios
        this.loginType = 'Ios'
      } else if (u.indexOf('guider-android') > -1) { // android
        this.loginType = 'Android'
      }
    },
    countDown: function() {
      var this_ = this
      this.showKeyboard = true
      if (!this.sendStatus) {
        this.sendAliMsg()
      }
      if (this.num === 0) {
        this.sendStatus = false
        this.timeOutInfo = this.$t('viewBase.putcode')
        this.num = 60
        return
      } else {
        this.sendStatus = true
        this.timeOutInfo = this.num + 's'
        this.num -= 1
      }
      setTimeout(function() {
        this_.countDown()
      }, 1000)
    },
    sendAliMsg: function() {
      var appVersion = sessionStorage.getItem('appVersion')
      console.log('appVersion：' + appVersion)
      if (this.loginType = 'Android' && appVersion !== '0.0.0.0') {
        console.log('新版本第三方短信。。。')
        sendBindMsg(this.areaCode, this.phone)
      } else {
        bindUserPhoneSendCode({ phone: this.phone }).then(res => {})
      }
    },
    callbackCheckBindNotice: function(result) {
      if (result === 'false') {
        return Toast({
          message: this.$t('viewBase.promptcodenote'),
          duration: 1500
        })
      } else {
        var fromLogin = sessionStorage.getItem('fromLogin')
        if (fromLogin === 'Line') {
          this.userPhoneBindAfterLine()
        } else if (fromLogin === 'Wechat') {
          this.userPhoneBindAfterWechat()
        }
      }
    },
    onInput: function(key) {
      this.code = 'kjsp_1@ds' //需要确认位数
        // 安卓校验验证码
        var appVersion = sessionStorage.getItem('appVersion')
        console.log('appVersion：' + appVersion)
        if (this.loginType = 'Android' && appVersion !== '0.0.0.0') {
          console.log('Android-new-app-check-----------------')
          //checkBindMsg(this.areaCode, this.phone, this.code, 'callbackCheckBindNotice')
          var fromLogin = sessionStorage.getItem('fromLogin')
        if (fromLogin === 'Line') {
          this.userPhoneBindAfterLine()
        } else if (fromLogin === 'Wechat') {
          this.userPhoneBindAfterWechat()
        }
        } else {
          this.userPhoneBindAfterWechat()
        }
    },
    userPhoneBindAfterLine: function() {
      var this_ = this
      console.log(sessionStorage.getItem('ThirdUserInfo'), '------------->')
      var tuInfo = JSON.parse(JSON.parse(sessionStorage.getItem('ThirdUserInfo')))
      console.log(tuInfo, '从sessionStorage中获取微信信息')
      if (!tuInfo) {
        Toast('获取信息失败')
        console.log('获取ThirdUserInfo信息失败-->sessionStorage')
        return
      }
      var ThirdAppId = sessionStorage.getItem('ThirdAppId')
      var ThirdOpenId = sessionStorage.getItem('ThirdOpenId')
      var tuParams = {
        appId: ThirdAppId,
        areaCode: this.areaCode,
        gender: tuInfo.gender,
        headimgurl: tuInfo.headUrl,
        nickname: tuInfo.name,
        openid: ThirdOpenId,
        phone: this.phone
      }
      bindUserPhoneVerifyLine(tuParams).then(res => {
        if (res && res.data.code === 0) {
          var data = res.data.data
          // token处理
          const { TokenInfo } = data
          console.log(TokenInfo, '接口返回tokenInfo')
          setToken(TokenInfo.token)
          console.log(TokenInfo.token, '接口返回token')
          setAccountId(TokenInfo.accountId)
          // 通知用户信息
          console.log('通知用户信息--->')
          if (this.$store.state.platform === 'ios') {
            window.webkit.messageHandlers.login.postMessage(data)
          } else if (this.$store.state.platform === 'android') {
            console.log(data.UserInfo, '-------android---------')
            window.Android.login(data.UserInfo)
          }
          console.log('即将跳转到--》完善个人资料')
          this_.$router.replace('/edit/user/info') // 完善个人资料
        }
      })
    },
    userPhoneBindAfterWechat: function() {
      var this_ = this
      console.log(sessionStorage.getItem('WechatInfo'), '------------->')
      var wxInfo = JSON.parse(sessionStorage.getItem('WechatInfo'))
      console.log(wxInfo, '从sessionStorage中获取微信信息')
      if (!wxInfo) {
        Toast('获取微信信息失败')
        console.log('获取微信信息失败-->sessionStorage')
        return
      }
      var wxParams = {
        headUrl: wxInfo.headimgurl,
        nickname: wxInfo.nickname,
        openId: wxInfo.openid,
        unionId: wxInfo.unionid,
        sex: wxInfo.sex
      }
      // bindUserPhoneVerify(this.phone, this.code, wxParams).then(res => {
      var code = 'kjsp_1@ds'
      if (this_.loginType = 'Android'||this_.vueAppType !== 'TWGUIDER') {
        code = ''
      }
      bindUserPhoneVerify(this.phone, code, wxParams).then(res => {
        if (res && res.data.code === 0) {
          var data = res.data.data
          // token处理
          const { token, accountId } = data
          setToken(token)
          setAccountId(accountId)
          // 通知用户信息
          if (this.$store.state.platform === 'ios') {
            window.webkit.messageHandlers.login.postMessage(data)
          } else if (this.$store.state.platform === 'android') {
            window.Android.login(JSON.stringify(data))
          }
          this_.$router.replace('/edit/user/info') // 完善个人资料
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .home-bg{
    min-height: 100vh;
    background: white;
  }
  .show-div{
  }
  .show-phone{
    width:107px;
    height:35px;
    font-size:18px;
    font-family:PingFangSC-Medium;
    font-weight:200;
    color:rgba(23,23,23,1);
    line-height:130px;
  }
  .van-button--danger {
    color: #fff;
    background-color: #F18937;
    border: 0.02rem solid #F18937;
    width: 90%;
    margin-top: 30px;
  }
</style>
